import { Text, Title } from "@mantine/core";
import type { JSX } from "react";

interface IProps {
    context: {
        documentName: string;
        startPart: number;
        endPart: number;
        totalParts: number;
    };
}

function ReadContext({ context }: IProps): JSX.Element {
    return (
        <>
            <Title order={5}>Document</Title>
            <Text>{context.documentName}</Text>
            <Title order={5}>Parts</Title>
            <Text>
                {context.startPart === context.endPart
                    ? `Part ${context.startPart} of ${context.totalParts}`
                    : `Parts ${context.startPart}-${context.endPart} of ${context.totalParts}`}
            </Text>
        </>
    );
}

export default ReadContext;
